import { render, staticRenderFns } from "./GenericIncident.vue?vue&type=template&id=cfcf5bb4&scoped=true"
import script from "./GenericIncident.vue?vue&type=script&lang=js"
export * from "./GenericIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcf5bb4",
  null
  
)

export default component.exports